export default __webpack_public_path__ + "static/media/TTT_mini_logo.e783c71e.jpg";